import merge from 'lodash/merge';

export const createAction = (type, defaults = {}) => (payload, meta = {}) =>
  merge({}, defaults, {
    type,
    payload,
    meta,
  });



// WEBPACK FOOTER //
// ./src/utils/redux/createAction.js